import { COLORS } from 'consts'
import { countries, numberUtils } from 'utils'

export default {
  chart: {
    toolbar: {
      show: false,
    },
    animations: {
      enabled: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '80%',
      dataLabels: {
        position: 'top',
      },
    },
  },
  dataLabels: {
    enabled: true,
    formatter: v => numberUtils.formatPercent(v, 1),
    textAnchor: 'start',
    offsetX: 25,
    style: {
      fontSize: '12px',
      color: COLORS.gray_dark1,
      colors: [COLORS.gray_dark1],
    },
  },
  legend: {
    show: false,
  },
  tooltip: {
    x: {
      formatter: v => countries.byValue(v).NAME,
    },
    y: {
      formatter: v => numberUtils.formatPercent(v, 1),
      title: {
        formatter: () => 'Percent',
      },
    },
  },
  stroke: {
    width: 0,
  },
  states: {
    normal: {
      filter: {
        type: 'none',
        value: 0,
      },
    },
    hover: {
      filter: {
        type: 'none',
      },
    },
    active: {
      filter: {
        type: 'none',
      },
    },
  },
  colors: [COLORS.primary],
  xaxis: {
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    floating: true,
  },
  grid: {
    padding: {
      top: -10,
      bottom: 0,
    },
  },
}
